import {
  APP_INITIALIZER,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import {
  DEFAULT_SESSION_CONFIG,
  SESSION_CONFIG,
  SessionConfig,
} from './session.model';
import { SessionService } from './session.service';

/**
 * Wires up `timedLogout`: binds the session config and re-arms the countdown at
 * bootstrap, so a page reload picks the session back up from the token still in
 * storage.
 *
 * Register it after `providePermissions` so permissions are loaded from the
 * token first.
 */
export function provideSession(
  config: Partial<SessionConfig> = {},
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SESSION_CONFIG,
      useValue: { ...DEFAULT_SESSION_CONFIG, ...config },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (session: SessionService) => () => session.start(),
      deps: [SessionService],
      multi: true,
    },
  ]);
}
